import _some from 'lodash/some';

export const canExecute = (user, action) => {
    return new Promise((resolve, reject) => {
        if (!user) reject('No user specified');
        if (!user.permissions) reject('User object missing permissions property');
        _some([
            user.permissions.includes(action),
            user.role.includes('admin') // legacy: backwards compatibility
        ])
            ? resolve()
            : reject();
    });
};
